import { permissionManager } from '../PermissionManager/PermissionManager';
// import {
//   PE_PLUGIN_PREMIUM_BTNS,
// } from 'Components/viewer/ui/constants/plugin.constants';

export const READ_MODE_BUTTON = 'read-mode-button';
export const READ_MODE_DOWNLOAD_FILE = 'read-mode-download-file-button';
export const READ_MODE_PRINT = 'read-mode-print-button';
export const AUTO_SCROLL_BUTTON = 'auto-scroll-button';
export const VIEW_LOUPE = 'loupe-button';

export const VIEW_SETTING_RULERS = 'toolbar-measure-rulers';
export const VIEW_SETTING_GUIDES = 'toolbar-measure-guides';
export const VIEW_SETTING_GRID = 'view-setting-grid';
export const VIEW_SETTING_SNAP_TO_GRID = 'view-setting-snap-to-grid';
export const VIEW_SETTING_LINE_WEIGHTS = 'view-setting-line-weights';
export const VIEW_SETTING_BOOKMARKS = 'view-setting-bookmarks';
export const VIEW_SETTING_PAGES = 'view-setting-pages';
export const VIEW_SETTING_COMMENTS = 'view-setting-comments';
export const VIEW_SETTING_ATTACHMENTS = 'view-setting-attachments';
export const VIEW_SETTING_SIGNATURES = 'view-setting-signatures';
export const VIEW_SETTING_FIELDS = 'view-setting-fields';
export const VIEW_SETTING_ARTICLES = 'view-setting-articles';
export const VIEW_SETTING_LAYERS = 'view-setting-layers';
export const VIEW_SETTING_HIDE_NAVIGATION_PANELS = 'view-setting-hide-navigation-panels';
export const VIEW_SETTING_SHOW_NAVIGATION_PANELS = 'view-setting-show-navigation-panels';
export const VIEW_SETTING_RESET_ALL_PANELS = 'view-setting-reset-all-panels';
export const VIEW_SETTING_DESTINATIONS = 'view-setting-destinations';
export const VIEW_SETTING_SHOW_STATUS_BAR = 'view-setting-show-status-bar';
export const VIEW_SETTING_AUTO_HIDE_STATUS_BAR = 'view-setting-auto-hide-status-bar';
export const VIEW_SETTING_HIDE_STATUS_BAR = 'view-setting-hide-status-bar';
export const DROPDOWN_ACTIVATE_READ = 'dropdown-activate-read';
export const DROPDOWN_DEACTIVATE_READ = 'dropdown-deactivate-read';
export const DROPDOWN_ADJUSTED_READ_RATE = 'dropdown-adjusted-read-rate';
export const DROPDOWN_ADJUSTED_READ_VOLUME = 'dropdown-adjusted-read-volume';
export const DROPDOWN_READ_CURRENT_PAGE = 'dropdown-read-current-page';
export const DROPDOWN_READ_FROM_CURRENT_PAGE = 'dropdown-read-from-current-page';
export const DROPDOWN_STOP_READ = 'dropdown-stop-read';
export const DROPDOWN_PAUSE_READ = 'dropdown-pause-read';
export const VIEW_COMPARE = 'view-compare-button';
export const VIEW_WORD_COUNT = 'word-count-button';
export const VIEW_TEXT_VIEWER = 'text-viewer-button';
export const EDIT_WITH_EDITOR_CLOUD = 'edit_with_editor_cloud';
export const SAVE_MODIFIED_PDF_DIRECTLY_FROM_LOCAL_OPENING = 'save_modified_pdf_directly_from_local_opening';
export const DOWNLOAD_MODIFIED_PDF_DIRECTLY_FROM_LOCAL_OPENING = 'download_modified_pdf_directly_from_local_opening';

export const VIEW_LIST = [
  READ_MODE_BUTTON,
  READ_MODE_DOWNLOAD_FILE,
  READ_MODE_PRINT,
  AUTO_SCROLL_BUTTON,
  VIEW_LOUPE,
  VIEW_SETTING_RULERS,
  VIEW_SETTING_GUIDES,
  VIEW_SETTING_GRID,
  VIEW_SETTING_SNAP_TO_GRID,
  VIEW_SETTING_LINE_WEIGHTS,
  VIEW_SETTING_BOOKMARKS,
  VIEW_SETTING_PAGES,
  VIEW_SETTING_COMMENTS,
  VIEW_SETTING_ATTACHMENTS,
  VIEW_SETTING_SIGNATURES,
  VIEW_SETTING_FIELDS,
  VIEW_SETTING_ARTICLES,
  VIEW_SETTING_LAYERS,
  VIEW_SETTING_HIDE_NAVIGATION_PANELS,
  VIEW_SETTING_SHOW_NAVIGATION_PANELS,
  VIEW_SETTING_RESET_ALL_PANELS,
  VIEW_SETTING_DESTINATIONS,
  VIEW_SETTING_SHOW_STATUS_BAR,
  VIEW_SETTING_AUTO_HIDE_STATUS_BAR,
  VIEW_SETTING_HIDE_STATUS_BAR,
];

export const VIEW_PREMIUM_BTNS = [
  DROPDOWN_ACTIVATE_READ,
  DROPDOWN_READ_CURRENT_PAGE,
  DROPDOWN_READ_FROM_CURRENT_PAGE,
  DROPDOWN_STOP_READ,
  DROPDOWN_ADJUSTED_READ_RATE,
  DROPDOWN_ADJUSTED_READ_VOLUME,
  DROPDOWN_PAUSE_READ,
  VIEW_COMPARE,
  VIEW_WORD_COUNT,
  VIEW_TEXT_VIEWER,
  VIEW_SETTING_RULERS,
  VIEW_SETTING_GUIDES,
  VIEW_SETTING_GRID,
  VIEW_SETTING_SNAP_TO_GRID,
  VIEW_SETTING_LINE_WEIGHTS,
  VIEW_SETTING_BOOKMARKS,
  VIEW_SETTING_PAGES,
  VIEW_SETTING_COMMENTS,
  VIEW_SETTING_ATTACHMENTS,
  VIEW_SETTING_SIGNATURES,
  VIEW_SETTING_FIELDS,
  VIEW_SETTING_ARTICLES,
  VIEW_SETTING_LAYERS,
  VIEW_SETTING_HIDE_NAVIGATION_PANELS,
  VIEW_SETTING_SHOW_NAVIGATION_PANELS,
  VIEW_SETTING_RESET_ALL_PANELS,
  VIEW_SETTING_DESTINATIONS,
  VIEW_SETTING_SHOW_STATUS_BAR,
  VIEW_SETTING_AUTO_HIDE_STATUS_BAR,
  VIEW_SETTING_HIDE_STATUS_BAR,
];

permissionManager.registerPremiumFeatures(VIEW_PREMIUM_BTNS);